import * as React from "react";

import { Form } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { ConfirmField, InputField, RadioPickerField } from "affinityForm/fields";
import { Button, ButtonVariants } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { Grid } from "affinityUI/elements/grid";
import { ButtonGroup, DataEntryGroup } from "affinityUI/form/components";
import { ROLES } from "lib/biot/roles/types";

export const UserForm: React.FC<{
  onCancel: () => void;
  invitationAccepted: boolean;
  isCreate: boolean;
  currentRoleId?: string;
}> = ({ onCancel: handleCancel, invitationAccepted, isCreate, currentRoleId }) => {
  return (
    <Card data-testid="userinfo-form">
      <Form>
        <DataEntryGroup title="User Information" id="user-information">
          <Grid $cols={[1, 1]}>
            <InputField name="firstName">First name</InputField>
            <InputField name="lastName">Last name</InputField>
          </Grid>
          <InputField name="employeeId">Employee ID</InputField>

          <ConfirmField name="email" confirmLabel="Confirm email" disabled={invitationAccepted}>
            Email
          </ConfirmField>
        </DataEntryGroup>
        <DataEntryGroup
          title="Access"
          description="Assign access to users by selecting the permission most suited to them."
          id="access"
        >
          <RadioPickerField name="roleId">
            {Object.values(ROLES)
              /**
               * NOTE: on creation, we show all options, on edit, we only allow changing between non-dashboard admin role,
               * or if already dashboard admin, they can't change roles
               ***/
              .filter((role) => (isCreate ? true : currentRoleId === "" ? role.id === "" : role.id !== ""))
              .map((roleInfo) => (
                <RadioPickerField.Option
                  key={roleInfo.id || "admin"}
                  value={roleInfo.id || "admin"}
                  label={roleInfo.name}
                >
                  {roleInfo.description}
                </RadioPickerField.Option>
              ))}
          </RadioPickerField>
        </DataEntryGroup>
        <ButtonGroup>
          <Button variant={ButtonVariants.SECONDARY} onClick={handleCancel}>
            Cancel
          </Button>
          <ExecuteButton>Continue to confirmation</ExecuteButton>
        </ButtonGroup>
      </Form>
    </Card>
  );
};
